import { IDataRow } from 'react-bootstrap-table-next';
import { IVendorPayoffData } from '../../../types/vendorDashboard/IVendorPayoffs';
import { BodyText, NavigationItem, TextTag } from '../../../ui-toolkit';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import React from 'react';
import { prettyVendorStatus, vendorStatusTagColor } from '../../../types/order/title/eTitleSearchStatus';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';
import { getDaysAgoString } from '../../../ui-toolkit/utilities/getDaysAgoString';

const fileNumberFormatter = (
  _cell: IDataRow<IVendorPayoffData>[keyof IDataRow<IVendorPayoffData>],
  row?: IDataRow<IVendorPayoffData>
) => {
  if (!row) return null;
  return (
    <NavigationItem
      appearance={'minimal'}
      intent={'primary'}
      text={row.fileNumber}
      to={clientUrls.urlFor.vendorPayoff(row.orderId)}
      isInline
    />
  );
};
const addressFormatter = (
  _cell: IDataRow<IVendorPayoffData>[keyof IDataRow<IVendorPayoffData>],
  row?: IDataRow<IVendorPayoffData>
) => {
  if (!row) return null;
  return <BodyText>{`${row.address.city}, ${row.address.stateAbbreviation}`}</BodyText>;
};

const timeEnteredQueueFormatter = (
  _cell: IDataRow<IVendorPayoffData>[keyof IDataRow<IVendorPayoffData>],
  row?: IDataRow<IVendorPayoffData>
) => {
  if (!row) return null;
  return <BodyText>{getDaysAgoString(row.timeEnteredQueue)}</BodyText>;
};

const etaFormatter = (
  _cell: IDataRow<IVendorPayoffData>[keyof IDataRow<IVendorPayoffData>],
  row?: IDataRow<IVendorPayoffData>
) => {
  if (!row) return null;
  return <BodyText>{getDateString(DateFormat.long, row.eta)}</BodyText>;
};

const statusFormatter = (
  _cell: IDataRow<IVendorPayoffData>[keyof IDataRow<IVendorPayoffData>],
  row?: IDataRow<IVendorPayoffData>
) => {
  if (!row) return null;
  return <TextTag type={vendorStatusTagColor[row.status]} text={prettyVendorStatus[row.status]} />;
};

export const PayoffsTableFormatters = {
  fileNumberFormatter,
  addressFormatter,
  timeEnteredQueueFormatter,
  etaFormatter,
  statusFormatter,
};
